import {
    INVENTORY_HISTORY_DATA,
    INVENTORY_HISTORY_ERROR,
    INVENTORY_HISTORY_LOADING,
    INVENTORY_HISTORY_PAGE_CHANGE,
    INVENTORY_HISTORY_STATE_CHANGE,
} from "../constants";
import { allHistoryColumns } from "./columns";
import { generateReducer } from "../../common/helpers";

const initialState = {
    error: null,
    inventories: [],
    isLoading: false,
    currentPage: 1,
    lastRow: null,
    pageSize: 25,
    sortModel: [
        {
            colId: "created_at",
            sort: "desc",
        },
    ],
    filterModel: {},
    columnDefs: Object.values(allHistoryColumns),
};

const setHistoryData = (state, { inventories, lastRow }) => {
    return {
        ...state,
        error: null,
        isLoading: false,
        lastRow,
        inventories,
    };
};

const changeHistoryPage = (state, currentPage) => ({ ...state, currentPage });
const changeHistoryState = (state, payload) => ({ ...state, ...payload });
const setHistoryLoading = state => ({ ...state, isLoading: true });
const setHistoryError = (state, error) => ({ ...state, isLoading: false, error });

const reducers = {
    [INVENTORY_HISTORY_DATA]: setHistoryData,
    [INVENTORY_HISTORY_ERROR]: setHistoryError,
    [INVENTORY_HISTORY_LOADING]: setHistoryLoading,

    [INVENTORY_HISTORY_PAGE_CHANGE]: changeHistoryPage,
    [INVENTORY_HISTORY_STATE_CHANGE]: changeHistoryState,
};

export default generateReducer(reducers, initialState);
